"use client"

import { useState, useEffect, useCallback } from "react"
import { ShoppingCartOutlined } from "@ant-design/icons"
import { Drawer, Button } from "antd"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../contexts/authContext/index"
import CartItem from "./CartItem"
const CartComponent = () => {
  const [cart, setCart] = useState([])
  const [drawerVisible, setDrawerVisible] = useState(false)
  const navigate = useNavigate()
  const { userLoggedIn } = useAuth()

  const handleCartClick = useCallback(() => {
    if (userLoggedIn) {
      setDrawerVisible(true)
    } else {
      navigate("/signin")
    }
  }, [navigate, userLoggedIn])

  useEffect(() => {
    const updateCart = (event) => {
      const cartItems = JSON.parse(localStorage.getItem("cart") || "{}")

      // Convert the cart object to an array and expand measures
      const cartArray = Object.entries(cartItems).flatMap(([productId, item]) =>
        (item.measures || []).map((measure) => ({
          id: productId,
          name: item.name,
          images: Array.isArray(item.images) ? item.images : [],
          measure: measure.measure,
          prices: Array.isArray(measure.prices) ? measure.prices : [],
          quantity: measure.quantity || 0,
        })),
      )

      setCart(cartArray)

      if (event && event.detail && event.detail.showDrawer) {
        handleCartClick()
      }
    }

    window.addEventListener("cartUpdated", updateCart)
    updateCart() // Load the cart initially

    return () => window.removeEventListener("cartUpdated", updateCart)
  }, [handleCartClick])

  const removeFromCart = (id, measure) => {
    const updatedCart = Object.entries(JSON.parse(localStorage.getItem("cart") || "{}")).reduce(
      (acc, [productId, item]) => {
        if (productId === id) {
          const updatedMeasures = (item.measures || []).filter((m) => m.measure !== measure)
          if (updatedMeasures.length > 0) {
            acc[productId] = { ...item, measures: updatedMeasures }
          }
        } else {
          acc[productId] = item
        }
        return acc
      },
      {},
    )

    localStorage.setItem("cart", JSON.stringify(updatedCart))

    // Update the cart state
    const updatedCartArray = Object.entries(updatedCart).flatMap(([productId, item]) =>
      (item.measures || []).map((measure) => ({
        id: productId,
        name: item.name,
        images: Array.isArray(item.images) ? item.images : [],
        measure: measure.measure,
        prices: Array.isArray(measure.prices) ? measure.prices : [],
        quantity: measure.quantity || 0,
      })),
    )
    setCart(updatedCartArray)

    window.dispatchEvent(new Event("cartUpdated"))
  }

  const navigateToCart = () => {
    navigate("/cart")
    setDrawerVisible(false)
  }

  const calculateTotalItems = () => {
    const totalItems = cart.reduce((total, item) => total + (item.quantity || 0), 0)
    return totalItems > 99 ? "+99" : totalItems
  }

  return (
    <>
      <div className="cart" onClick={handleCartClick}>
        <div className="cart-icon">
          <ShoppingCartOutlined />
          <span className="cart-badge">{calculateTotalItems()}</span>
        </div>
      </div>
      <Drawer
        title="Carrito de Compras"
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={350}
      >
        {cart.length === 0 ? (
          <p>Tu carrito está vacío</p>
        ) : (
          <div>
            <div className="cart-items-container" style={{ overflowY: "auto", maxHeight: "70vh" }}>
              {cart.map((item, index) => (
                <CartItem key={`${item.id}-${item.measure}`} item={item} onRemove={removeFromCart} />
              ))}
            </div>

            <Button
              type="primary"
              onClick={navigateToCart}
              className="cart-view-button"
              style={{ width: "100%", marginTop: "10px" }}
            >
              Ver carrito
            </Button>
          </div>
        )}
      </Drawer>
    </>
  )
}

export default CartComponent

